import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSampleViewHeader from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-view-header/grossing-touch-sample-view-header.vue'
import GrossingTouchMediaCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-media-card/grossing-touch-media-card.vue'
import GrossingTouchMediaSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-media-sidepanel/grossing-touch-media-sidepanel.vue'

@Component({
    components: {
        GrossingTouchSampleViewHeader,
        GrossingTouchMediaCard,
        GrossingTouchMediaSidepanel
    }
})

export default class GrossingTouchSampleTabMedia extends Vue {
    private grossingPictures !: Array<object>
    private grossingEditedPictures !: Array<object>

    constructor() {
        super()
        this.grossingPictures = [
            {
                filename: 'Picture_name_1.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_2.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_3.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_4.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_5.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            }
        ]
        this.grossingEditedPictures = [
            {
                filename: 'Picture_name_1.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            },
            {
                filename: 'Picture_name_2.jpg',
                creationDate: '17/03/2022 12:34',
                createdBy: {
                    fullName: 'LIS, Anapath'
                }
            }
        ]
    }
}
